'use strict';



const _=require('pulsar-utils/dist-es6/_');
const BaseDirective=require('../../../../dist-es6/client/angularCommon/baseDirective');let

TreeListItemDirective=class TreeListItemDirective extends BaseDirective{
get restrict(){
return'E';
}

get objectBindings(){
return['items','treeList','rootItem'];
}

get templateUrl(){
return'/templates/directives/treeListDirective/treeListItemTemplate';
}

factory($compile){
let directive=super.factory();
directive.transclude=!0;
directive.compile=(tElement,tAttr,transclude)=>{


var contents=tElement.contents().remove();
var compiledContents;
return function(scope,iElement,iAttr){

if(!compiledContents){


compiledContents=$compile(contents,transclude);
}






compiledContents(scope,function(clone,scope){


iElement.append(clone);

const itemButton=angular.element(iElement).parent().find('> .item');
scope.treeList.itemToElementMap.set(scope.rootItem,itemButton);
});
};
};

return directive;
}};


module.exports=TreeListItemDirective;
module.exports.prototype.factory.$inject=['$compile'];
//# sourceMappingURL=treeListItemDirective.js.map
